import Strings from "@my-dld/assets/strings";
import { RTRequestStatusId } from "@eres/rtregistrationapi/entities";
import { OwnerVIPRequestStatus } from "@eres/vipownerapi/entities";
import { TabuRequestStatusType, TabuRequestUtils } from "@10x/tabu-mobile-api";
import { ProcedureDetail, ProcedureIDs } from "@10x/tabu-mobile-api/dist/requests/entity";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { getAppServices } from "@10x/coreapp";


export function getTabuRequestStatus( statusId: number ) {
	return Strings[ TabuRequestUtils.tabuRequestStatus( statusId ) ];
}

export function getTabuRequestStatusClass( statusId: number ) {
	switch ( statusId ) {
		case TabuRequestStatusType.ENTERED:
			return "entered";
		case TabuRequestStatusType.PENDING_PAYMENT:
			return "pending-payment";
		case TabuRequestStatusType.PAID:
			return "paid";
		case TabuRequestStatusType.COMPLETED:
			return "completed"; //
		case TabuRequestStatusType.REJECTED:
			return "rejected";
		case TabuRequestStatusType.CANCELLED:
			return "cancelled";
		default :
			return "entered";
	}
}

export function getRTRequestStatus( statusId: number ) {
	switch ( statusId ) {
		case RTRequestStatusId.PENDING:
			return Strings.pending;
		case RTRequestStatusId.PICKUP:
			return Strings.picked_up;
		case RTRequestStatusId.UNDER_AUDITING:
			return Strings.under_auditing;
		case RTRequestStatusId.CANCEL:
			return Strings.cancelled;
		case RTRequestStatusId.COMPLETED:
			return Strings.completed;
		default:
			return Strings.pending;
	}
}

export function getRTRequestStatusClass( statusId: number ) {
	switch ( statusId ) {
		case RTRequestStatusId.PENDING:
			return "pending";
		case RTRequestStatusId.PICKUP:
			return "pickup";
		case RTRequestStatusId.UNDER_AUDITING:
			return "under-auditing";
		case RTRequestStatusId.CANCEL:
			return "cancelled";
		case RTRequestStatusId.COMPLETED:
			return "completed";
		default:
			return "pending";
	}
}

export function getVIPRequestStatus( statusId: number ) {
	switch ( statusId ) {
		case OwnerVIPRequestStatus.PENDING:
			return Strings.pending;
		case OwnerVIPRequestStatus.PICKED:
			return Strings.picked_up;
		case OwnerVIPRequestStatus.CANCEL:
			return Strings.cancelled;
		case OwnerVIPRequestStatus.COMPLETED:
			return Strings.completed;
		default:
			return Strings.pending;
	}
}

export function getVIPRequestStatusClass( statusId: number ) {
	switch ( statusId ) {
		case OwnerVIPRequestStatus.PENDING:
			return "pending";
		case OwnerVIPRequestStatus.PICKED:
			return "picked";
		case OwnerVIPRequestStatus.CANCEL:
			return "cancelled";
		case OwnerVIPRequestStatus.COMPLETED:
			return "completed";
		default:
			return "pending";
	}
}

export function isMultiPropertyProcedure( serviceID: ProcedureIDs ) {
	return serviceID === ProcedureIDs.PROPERTY_ANNEX || serviceID === ProcedureIDs.DELAYED_PROPERTY_ANNEX;
}

export function getAssetFromProcedure( details: ProcedureDetail ): AssetCard[] {
	const properties: AssetCard[] = [];
	if ( details && details.PropertyInfo ) {
		const store = getAppServices().storeService.getStore();
		const assets = store.getState().UserData.properties;
		details.PropertyInfo.forEach( property => {
			const a = assets?.find( asset => asset.propertyId === property.Identity );
			if ( a ) {
				properties.push( a );
			}
		} );
	}
	return properties;
}
